import './intro.scss';
import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '@assets/images/logo.svg';
import { Button } from '@shared/button';
import { useTranslation } from '@shared/i18n';

export default function IntroPage(): ReactElement {
  const translate = useTranslation('ACCOUNT_ACCESS.INTRO');
  const landingURL = process.env.REACT_APP_LANDING_URL;
  const navigate = useNavigate();

  const loginButtonClicked = (): void => {
    navigate('/login');
  };

  return (
    <div className='intro content'>
      <div className='intro-logo'>
        <img src={logo} alt={translate('TEXT_LOGO')} />
      </div>
      <div className='intro-actions'>
        <a href={landingURL}>
          <Button className='intro-signup' isBlock>
            {translate('BUTTON_SIGN_UP')}
          </Button>
        </a>
        <Button
          onClick={loginButtonClicked}
          variant='secondary'
          isBlock>
          {translate('BUTTON_LOGIN')}
        </Button>
      </div>
    </div>
  );
}
